import i18n from "i18next";
import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { reactI18nextModule } from "react-i18next";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(reactI18nextModule)
  .init({
    // Only load the full locale we actually ship; don't probe base 'en'
    load: "currentOnly",
    supportedLngs: ["en-US", "zh-CN", "zh-TW"],
    fallbackLng: "en-US",

    // Your namespace/file name is 'translations'
    ns: ["translations"],
    defaultNS: "translations",

    // Point to where CRA serves them in production
    backend: {
      loadPath: `${process.env.PUBLIC_URL || ""}/locales/{{lng}}/{{ns}}.json`,
    },

    // Old react-i18next option (v9 era) to wait for resources
    react: { wait: true },

    // Be resilient if keys are missing
    returnNull: false,
    returnEmptyString: false,
    debug: false,
  });

// ✅ Make t() permanently bound to the i18n instance
const boundT = i18n.t.bind(i18n);
i18n.t = boundT;

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js